module.exports = __webpack_public_path__ + "videos/home_en.4be1c74.mp4";